import React, { useEffect, useState } from 'react';
import { Router } from '@reach/router';
import { auth, db } from './api/firebase';

import 'fontsource-roboto';

import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import PasswordReset from './components/PasswordReset';
import Categories from './components/Categories';
import UserContext from './api/UserContext';
function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    auth.onAuthStateChanged((userAuth) => {
      setUser(userAuth);
      setLoading(false);
    });
  }, []);
  //console.log(user);
  if (loading) return <div>Loading</div>;

  return user ? (
    <UserContext.Provider value={user}>
      <Categories />
    </UserContext.Provider>
  ) : (
    <Router>
      <SignUp path="SignUp" />
      <SignIn path="/" />
      <PasswordReset path="PasswordReset" />
    </Router>
  );
}

export default App;
